module.exports = __webpack_public_path__ + "static/media/Icon_Profil_Erstellen.908a0f46.svg";